export enum UserRole {
  ADMIN = "admin",
  MANAGER = "manager",
  EMPLOYEE = "employee",
}

export enum RoleMemberProject {
  LEADER = 'leader',
  DEVELOPER = 'developer',
  DESIGNER = 'designer',
  QA = 'qa',
  PROJECT_MANAGER = 'project_manager',
  TESTER = 'tester',
  TECHNICAL_WRITER = 'technical_writer',
  CLIENT = 'client',
  OTHER = 'other',
}